import React from 'react';
import 'twin.macro';

export const Divider = ({ ...restProps }) => (
  <hr tw='my-4 border-icons opacity-60' {...restProps} />
);
